$(document).ready(function(){
  $(".owl-carousel").owlCarousel({
    items: 4, // Number of items per slide
    loop: true, // Loop through items
    margin: 10, // Margin between items
    autoplay: false, // Auto-play
    autoplayTimeout: 3000, // Time between slides
    autoplayHoverPause: true, // Pause on hover
    responsive: {
      0: {
        items: 1 // 1 item below 500px
      },
      500: {
        items: 2 // 2 items between 500px and 999px
      },
      749: {
        items: 3 // 3 items between 1000px and 1409px
      },
      1410: {
        items: 4 // 4 items above 1410px
      }
    }
  });
});